import React from 'react'
// import together from '../../icons/together.jpeg'
// import frontpageMenuEng from '../../icons/MenuEngineering_front.png'
// import gamification_front from '../../icons/gamification_front.png'
// import gamificationPDF from '../../assests/JetMenugamification.pdf'
// import menuEngineeringPDF from '../../assests/JetMenu_MenuEngineering.pdf'


function HomePageInfoSection() {
  return (
    <>
        <div className='HomePageInfoSection'>
        <div className="heading">
            <h4>How to use Mokuren ?</h4>
            <h2>Mokuren is a loyalty app designed for small businesses in Japan.</h2>
            <h3>「Mokuren」は、日本の小規模事業者向けに設計されたロイヤルティアプリです。</h3>
        </div>
        <div className="info-body">
             {/* Use your app image */}
            {/* <img src={together} alt="" /> */}
            <ul>
                <div className="info-body-card">
                    <li><span>&#x2713;</span> Create your business account on Mokuren</li>
                    <li><span>&#x2713;</span> Set-Up your loyalty program in less than 1 minute</li>
                </div>
                <div className="info-body-card">
                    <li><span>&#x2713;</span><strong>Start using it!!</strong></li>
                    <li><span>&#x2713;</span>Use your iPad as Kiosk and display it in your front desk</li>
                </div>
                <div className="info-body-card">
                <li><span>&#x2713;</span>Customers are able to enter their phone number to join.</li>
                <li><span>&#x2713;</span>Your customers will get informed via SMS once they can redeem loyalty benefits</li>
                </div>
                <li><span>&#x2713;</span><strong>Connect with your customers through Mokuren</strong></li>
            </ul>
        </div>
        {/* <button className='start'>Try 30 days for Free</button> */}
    </div>
    </>
  )
}

export default HomePageInfoSection